import { render, staticRenderFns } from "./ArtCounter.vue?vue&type=template&id=4389fa19"
import script from "./ArtCounter.vue?vue&type=script&lang=js"
export * from "./ArtCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports